var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"table-container"},[_c('table',{class:`list ${_vm.compact ? 'compact' : ''}`},[(!!_vm.$slots.header)?_c('tr',{staticClass:"header"},[_vm._t("header")],2):_vm._e(),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }